import extend from './src/extend';

app.initializers.add('flover-upload-md-to-compose', extend);
